import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50661780"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "abusolute-center bg-white shadow-lg w-full sm:w-max rounded-lg" };
const _hoisted_2 = {
    class: "py-8 px-5 sm:px-12",
    id: "app"
};
const _hoisted_3 = { class: "grid grid-cols-1 gap-6" };
const _hoisted_4 = { class: "block" };
const _hoisted_5 = { class: "text-gray-700" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_7 = { class: "my-2 flex" };
const _hoisted_8 = ["value"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "storeManager",
    class: "radio-label w-1/3 text-center mr-1 px-2 py-2 border border-gray-400 bg-white text-gray-500 hover:bg-gray-100"
}, "店舗管理者", -1));
const _hoisted_10 = ["value"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "manager",
    class: "radio-label w-1/3 text-center mr-1 px-2 py-2 border border-gray-400 bg-white text-gray-500 hover:bg-gray-100"
}, "本部管理者", -1));
const _hoisted_12 = { class: "block" };
const _hoisted_13 = { class: "text-gray-700" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_15 = { class: "block" };
const _hoisted_16 = { class: "text-gray-700" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_18 = { class: "block" };
const _hoisted_19 = { class: "text-gray-700" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_21 = { class: "block" };
const _hoisted_22 = { class: "text-gray-700" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_24 = { class: "flex justify-center mt-12" };
const _hoisted_25 = { class: "block" };
const _hoisted_26 = { class: "block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_ErrMsgCard = _resolveComponent("ErrMsgCard");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Title, {
                msg: "ユーザ登録",
                submsg: "User Register"
            }),
            _createElementVNode("form", {
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.userRegister && _ctx.userRegister(...args)), ["prevent"])),
                class: "text-gray-700"
            }, [
                _createVNode(_component_ErrMsgCard, {
                    errMsgs: $data.errMsgs,
                    process: "管理ユーザ登録"
                }, null, 8, ["errMsgs"]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString($data.authType.key), 1),
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "storeManager",
                                name: "auth",
                                value: $data.storeAdmin,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.authType.value) = $event)),
                                class: "radio-button:border-gray-600 radio-button:text-white radio-button:bg-gray-600 hidden",
                                checked: ""
                            }, null, 8, _hoisted_8), [
                                [_vModelRadio, $data.authType.value]
                            ]),
                            _hoisted_9,
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "manager",
                                name: "auth",
                                value: $data.systemAdmin,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.authType.value) = $event)),
                                class: "radio-button:border-gray-600 radio-button:text-white radio-button:bg-gray-600 hidden"
                            }, null, 8, _hoisted_10), [
                                [_vModelRadio, $data.authType.value]
                            ]),
                            _hoisted_11
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString($data.crmUserId.key), 1),
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.crmUserId.value) = $event)),
                            class: "w-full"
                        }, null, 512), [
                            [_vModelText, $data.crmUserId.value]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString($data.userName.key), 1),
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.userName.value) = $event)),
                            class: "w-full"
                        }, null, 512), [
                            [_vModelText, $data.userName.value]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString($data.storeId.key), 1),
                        _hoisted_20,
                        ($data.systemAdmin == $data.authType.value)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.adminStoreCd) = $event)),
                                class: "w-full",
                                readonly: ""
                            }, null, 512)), [
                                [_vModelText, $data.adminStoreCd]
                            ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "text",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.storeId.value) = $event)),
                                class: "w-full"
                            }, null, 512)), [
                                [_vModelText, $data.storeId.value]
                            ])
                    ]),
                    _createElementVNode("label", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString($data.phoneNum.key), 1),
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($data.phoneNum.value) = $event)),
                            class: "w-full"
                        }, null, 512), [
                            [_vModelText, $data.phoneNum.value]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, [
                        _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$router.go(-1))),
                            name: "buck-button",
                            class: "btn btn-gray w-full mr-5 md:mr-10"
                        }, " 戻る ")
                    ]),
                    _createElementVNode("label", _hoisted_26, [
                        _createElementVNode("button", {
                            onClick: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => ($options.register && $options.register(...args))),
                            name: "button",
                            class: "btn btn-red w-full"
                        }, " 登録 ")
                    ])
                ])
            ], 32)
        ])
    ]));
}
